(() => {
  const initializeNavigation = () => {
    document.querySelectorAll('.ac-editorial-header__navigation').forEach(navigation => {
      if (navigation.dataset.initialized) return;
      navigation.dataset.initialized = 'true';
      const list = navigation.querySelector('.ac-editorial-header__links');
      const items = [...list.children];
      const overflow = navigation.querySelector('.ac-editorial-header__overflow');
      const overflowItems = [...overflow.querySelector('.menu__list').children];
      const fit = () => {
        if (!navigation.clientWidth) return;
        items.forEach(item => { item.hidden = false; });
        overflow.hidden = true;
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        const widths = items.map(item => item.getBoundingClientRect().width);
        let count = items.length;
        let width = widths.reduce((total, value) => total + value, 0) + gap * Math.max(0, count - 1);
        if (width > navigation.clientWidth) {
          overflow.hidden = false;
          const available = navigation.clientWidth - overflow.getBoundingClientRect().width
            - (parseFloat(getComputedStyle(navigation).columnGap) || 0);
          while (count && width > available) {
            count--;
            width -= widths[count] + (count ? gap : 0);
          }
        }
        items.forEach((item, index) => { item.hidden = index >= count; });
        overflowItems.forEach((item, index) => { item.hidden = index < count; });
        if (overflow.hidden) overflow.open = false;
      };
      new ResizeObserver(fit).observe(navigation);
      document.fonts.ready.then(fit);
    });
  };
  initializeNavigation();
  document.addEventListener('shopify:section:load', initializeNavigation);
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.ac-editorial-header__search') && event.target.open) {
      event.target.querySelector('input[type="search"]')?.focus();
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ac-editorial-header__search[open], .ac-editorial-header__overflow[open]').forEach(search => {
      search.open = false;
      search.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.ac-editorial-header__search[open], .ac-editorial-header__overflow[open]').forEach(search => {
      if (!search.contains(event.target)) search.open = false;
    });
  });
})();
